<template>
  <div class="m-chart-stack">
    <p
      v-if="!total"
      class="m-chart-stack-empty"
    >
      {{ emptyText }}
    </p>
    <div v-else>
      <div class="m-chart-stack-bar">
        <span
          v-for="item in series"
          :key="'seg-' + item.key"
          :class="['m-chart-stack-segment', 'a-tooltip-primary', 'a-tooltip-top']"
          :data-tooltip-text="`${item.label}: ${item.text}`"
          :style="{ backgroundColor: item.color, width: segmentWidth(item.value) }"
        ></span>
      </div>
      <!--
        Leyenda + valores escritos. La leyenda sola no alcanza: hay tonos de la paleta que no llegan
        a 3:1 contra el blanco, asi que el reparto tiene que poder leerse tambien como numeros.
      -->
      <ul class="m-chart-stack-legend">
        <li
          v-for="item in series"
          :key="'leg-' + item.key"
          class="m-chart-stack-legend-item"
        >
          <span
            class="m-chart-stack-legend-swatch"
            :style="{ backgroundColor: item.color }"
          ></span>
          <span class="m-chart-stack-legend-label">{{ item.label }}</span>
          <span class="m-chart-stack-legend-value">
            {{ item.text }}
            <span class="m-chart-stack-legend-share">{{ sharePercent(item.value) }}</span>
          </span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
/*
 | Reparto parte-todo en una sola barra apilada horizontal, hecha con HTML y CSS.
 |
 | Aca el color SI es identidad (cada segmento es una categoria distinta), asi que lleva leyenda
 | siempre. Los segmentos se separan con un hueco del color del fondo, nunca con un borde.
 | Pensado para pocas categorias: con mas de seis un reparto deja de leerse y conviene una tabla.
 */
export default {
  name: 'MoleculeChartStack',

  props: {
    emptyText: {
      type: String,
      default: ''
    },

    // [{ key, label, value, text, color }] — text es el valor ya formateado
    series: {
      type: Array,
      default: () => []
    }
  },

  computed: {
    total () {
      return this.series.reduce((suma, item) => suma + (Number(item.value) || 0), 0)
    }
  },

  methods: {
    segmentWidth (valor) {
      const ancho = (Math.max(Number(valor) || 0, 0) / (this.total || 1)) * 100

      return ancho > 0 && ancho < 1 ? '2px' : `${ancho}%`
    },

    sharePercent (valor) {
      const parte = (Math.max(Number(valor) || 0, 0) / (this.total || 1)) * 100

      return `${parte.toFixed(1)} %`
    }
  }
}
</script>
